
import React,{useEffect,useState} from 'react'
import {Helmet} from "react-helmet";
import { useLocation } from '@reach/router';
import { ToastContainer } from 'react-toastify';
import  {getsessionid} from '../../service/trackingService'
import 'react-toastify/dist/ReactToastify.css';
import {isMobile} from 'react-device-detect';
import {Home,Redirect} from "../../utils/constant";
import Footer from '../../components/Footer/footer1';
import Header1 from '../Header/Header1';
// import { Script } from "gatsby";


import "./layoutbibomart.css";
const Lighttheme = ({ children }) => {
    const locationlink = useLocation();
    // console.log = () => {}
    // console.error = () => {}
    // console.debug = () => {}
    // let yourAndroidDeepLink = 'https://play.google.com/store/apps/details?id=vn.com.bibomart.bibomart';    
    // let yourIOSDeepLink = 'https://apps.apple.com/vn/app/bibo-mart-siêu-thị-mẹ-và-bé/id1464298193?l=vi';

    // const [operatingSystem, setOperatingSystem] = useState('Windows');
    // const getOS = ()=> {
    //     var uA = navigator.userAgent || navigator.vendor || window.opera;
    //     if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) 
    //     { setOperatingSystem('iOS');}
      
    //     var i, os = ['Windows', 'Android', 'Unix', 'Mac', 'Linux', 'BlackBerry'];
    //     for (i = 0; i < os.length; i++) if (new RegExp(os[i],'i').test(uA)) {
    //         setOperatingSystem(os[i]);
    //     }     
    // }
    const [loading, setLoading] = useState(true);
    useEffect(()=>{
        const _path = locationlink.pathname;
        if(Home.includes(_path) === true){
            window.location.href = '/';
        }

        for (var key in Redirect){
            if(key === _path){
                window.location.href = Redirect[key];
            }
        }  

        if(isMobile){
            if(locationlink.pathname.includes('/account/') === true){
                window.location.href = '/mobile/manager.html';
                return;
            }
        }
       
        const searchParams = new URLSearchParams(locationlink.search);
        let _userReferral = searchParams.get("userReferral")??''; 
        if(searchParams.has("userReferral") && searchParams.get("userReferral") !== undefined){
            window.localStorage.setItem('userReferral', _userReferral);
        }
        let _idShare = searchParams.get("idShare"); 
        if(searchParams.has("idShare") && searchParams.get("idShare") !== undefined){
            window.localStorage.setItem('idShare', _idShare);
        }
       
        // getOS();
        setTimeout(()=>{
            setLoading(false)
        },10);

        const _session_id = window.localStorage.getItem('sessionId')??'';
        if (_session_id === '') {
            try{
                getsessionid().then((response)=>{
                    if(+response.status === 200){
                        window.localStorage.setItem('sessionId',response?.message);
                    }
                });
            }catch(e){console.log(e);}
        }

    },[]);
return (
    <>
    <Helmet defer={false} htmlAttributes={{ lang : 'vi-vn'}}>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
    <meta name="robots" content="index, follow, noodp, noydir"/>
    <meta name="googlebot" content="index, follow"/>
    <meta name="language" content="vietnamese"/>
    {/* <meta name="viewport" content="width=device-width, initial-scale=1.0"/> */}
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/>
    {/* <style>
        {loadstyle}
    </style> */}
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet" />
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.3.0/font/bootstrap-icons.css"/>
    <link rel="stylesheet" href="/static/css/Lighttheme.min.css" type="text/css" />
    <link rel="stylesheet" href="/static/css/categories.min.css" type="text/css" />

    {/* <link rel="stylesheet" href="/static/css/Lighttheme.css" type="text/css" />
    <link rel="stylesheet" href="/static/css/categories.css" type="text/css" /> */}
  
    <meta name="google-site-verification" content="gl5_s8SLuTXPujLll0Ys0-ngADkXFw5E0-YvL2xaGNA" />
    <noscript>{`<meta name="google-site-verification" content="gl5_s8SLuTXPujLll0Ys0-ngADkXFw5E0-YvL2xaGNA"/>`}</noscript>
    <script>
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-W4DFJPRZ');`}
    </script>

    {/* <script src="https://www.googletagmanager.com/gtag/js?id=G-KJQ1RG9VRB"></script>

    <script>
    {`window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-KJQ1RG9VRB');`}
    </script> */}

    <link rel="icon" type="image/x-icon" href="/images/favicon.png" />
    <script type="application/ld+json">
        {`{
            "@context": "https://schema.org/",
            "@type": "WebSite",
            "name": "bibomart",
            "url": "https://bibomart.com.vn/",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://bibomart.com.vn/ket-qua-tim-kiem.html?{search_term_string}",
                "query-input": "required name=search_term_string"
                }
        }`}
    </script>

    <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.8/dist/umd/popper.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.min.js"></script>
    <body className="position-relative" id='lighttheme'/>
    <noscript>{`<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W4DFJPRZ" height="0" width="0" style="display:none;visibility:hidden"></iframe>`}</noscript>
    <script src="https://sp.zalo.me/plugins/sdk.js"></script>
    {/* <link rel="stylesheet" href="https://code.jquery.com/mobile/1.4.5/jquery.mobile-1.4.5.min.css"  media="screen"/>
<script src="https://code.jquery.com/mobile/1.4.5/jquery.mobile-1.4.5.min.js"></script> */}
    </Helmet>
        {

        // <div id="wrapper">
        // <div id="landing-web">
        //         <div className="loading-page"  style={{textAlign:"center"}}>
        //             <img src="/../images/loading.gif" alt="img"/>
        //         </div>
        //     </div>
        // </div>
                loading === true ? (null):(
            <>
            <Header1/>
            <main>
                {children}
            </main>
            <Footer/> 
            <div className="zalo-chat-widget zalo bg-white overflow-hidden" data-oaid="360706546542426311" data-welcome-message="Rất vui khi được hỗ trợ bạn!" data-autopopup="0" data-width="" data-height=""></div>
            </>
            )
        }
    <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        />
    </>
  )
}

export default Lighttheme